export const DEBUG = false;
export const SERVER_URL = "https://esead.unex.es/rest/";
export const DOMAIN = "https://esead.unex.es/";
/*export const SERVER_URL = "https://cuestionariosuex.himalayac.com/rest/";
export const DOMAIN = "https://cuestionariosuex.himalayac.com/";*/
/*export const SERVER_URL = "http://localhost/cuestionarios-uex/rest/";
export const DOMAIN = "http://localhost/";*/

export async function post(op, body = {}, responseType = "json") {
  let data = null;
  let dataOr = null;
  try {
    if (DEBUG) {
      console.log(SERVER_URL + op + ".php");
      console.log(body);
    }
    const response = await fetch(SERVER_URL + op + ".php", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    if (DEBUG) {
      console.log(response);
    }
    dataOr = await response.text();
    if (responseType === "json") {
      data = await JSON.parse(dataOr);
      if (DEBUG) {
        console.log(data);
      }
    }
  } catch (error) {
    if (DEBUG) {
      console.log(error);
      console.error("BACKGROUND ERROR - " + dataOr);
    }
  }
  return data;
}
